<span 
		class="logo-wrapper"
		[ngClass]="article.field_logo_margin_1 ? 'margin' : ''"
		*ngIf="article.field_logo_1"
		>
		<figure 
				class="media" 
				[ngStyle]="{'background-image': 'url(' + article.field_logo_1 + ')'}"
			></figure>
	</span>